import React from 'react';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import {
  Box,
  Button,
  TextField,
  FormHelperText,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { postRegisterPublic } from '../../requests/api/auth';
import handleApiResponse from '../../utils/http';

const validationSchema = Yup.object().shape({
  name: Yup.string().min(2, 'Mínimo 2 caracteres').max(255).required('Nombre requerido'),
  lastname: Yup.string().min(2, 'Mínimo 2 caracteres').max(255).required('Apellidos requeridos'),
  email: Yup.string().email('Correo no válido').required('Correo electrónico requerido'),
});

function RegisterForm({ className, onSuccess }) {
  const { enqueueSnackbar } = useSnackbar();

  const handleRegisterSubmit = async (values, { setSubmitting }) => {
    try {
      await postRegisterPublic({
        name: values.name,
        lastname: values.lastname,
        email: values.email,
      });
      setSubmitting(false);
      onSuccess?.();
    } catch (error) {
      handleApiResponse(enqueueSnackbar, error, false);
      setSubmitting(false);
    }
  };

  const inputBorderStyle = (touched, error) => ({
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: touched && error ? 'transparent' : 'black',
    borderRadius: 0,
    background: '#fff',
  });

  return (
    <Formik
      initialValues={{
        name: '',
        lastname: '',
        email: '',
      }}
      validationSchema={validationSchema}
      onSubmit={handleRegisterSubmit}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit: onFormSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={onFormSubmit}>
          <Box display="flex" gap={2} mb={2}>
            <TextField
              fullWidth
              name="name"
              label="Nombre"
              placeholder="Nombre"
              value={values.name}
              onBlur={handleBlur}
              onChange={handleChange}
              error={Boolean(touched.name && errors.name)}
              helperText={touched.name && errors.name}
              variant="outlined"
              InputProps={{
                style: inputBorderStyle(touched.name, errors.name),
              }}
            />
            <TextField
              fullWidth
              name="lastname"
              label="Apellidos"
              placeholder="Apellidos"
              value={values.lastname}
              onBlur={handleBlur}
              onChange={handleChange}
              error={Boolean(touched.lastname && errors.lastname)}
              helperText={touched.lastname && errors.lastname}
              variant="outlined"
              InputProps={{
                style: inputBorderStyle(touched.lastname, errors.lastname),
              }}
            />
          </Box>
          <TextField
            fullWidth
            name="email"
            label="Correo electrónico"
            placeholder="Correo electrónico"
            type="email"
            value={values.email}
            onBlur={handleBlur}
            onChange={handleChange}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
            variant="outlined"
            margin="normal"
            InputProps={{
              style: inputBorderStyle(touched.email, errors.email),
            }}
          />
          <Box mt={3}>
            <Button
              className={className?.button}
              disabled={isSubmitting}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
            >
              CREAR CUENTA
            </Button>
            {errors.submit && (
              <Box mt={2}>
                <FormHelperText error>{errors.submit}</FormHelperText>
              </Box>
            )}
          </Box>
        </form>
      )}
    </Formik>
  );
}

RegisterForm.propTypes = {
  className: PropTypes.object,
  onSuccess: PropTypes.func,
};

RegisterForm.defaultProps = {
  onSuccess: () => {},
};

export default RegisterForm;
